module.exports = __webpack_public_path__ + "static/media/courses.0d2181d8.svg";